import delv from 'dlv';

import { ISanityTextNode } from '@rbi-ctg/menu';

export function hasPropertyLocale<K extends string>(
  subject: { [P in K]: ISanityTextNode | null },
  property: K
): subject is { [P in K]: ISanityTextNode } {
  const locale = delv(subject, `${property}.locale`, '');

  return locale !== null && locale.trim() !== '';
}
